/**
 * In-memory tracking of pending PDF conversions.
 * Maps processId -> { fileId, destinationFolderId, sourceFileName, startedAt }
 */

interface PendingConversion {
  fileId: number;
  /** Destination chosen at convert start; null = personal root. */
  destinationFolderId: number | null;
  /** Source file title (no path); used to find PDF when BE omits new_file_id. */
  sourceFileName?: string;
  startedAt: number;
}

const pendingConversions = new Map<string, PendingConversion>();

export function addPendingConversion(
  processId: string,
  fileId: number,
  destinationFolderId: number | null = null,
  sourceFileName?: string,
): void {
  pendingConversions.set(processId, {
    fileId,
    destinationFolderId,
    sourceFileName,
    startedAt: Date.now(),
  });
}

export function getPendingConversion(processId: string): PendingConversion | undefined {
  return pendingConversions.get(processId);
}

export function removePendingConversion(processId: string): void {
  pendingConversions.delete(processId);
}

export function hasPendingConversion(processId: string): boolean {
  return pendingConversions.has(processId);
}

export function resetPendingConversionsForTests(): void {
  pendingConversions.clear();
}
